import { Typography } from "@mui/material";
import moment from "moment";
import { useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useReactToPrint } from "react-to-print";
import CustomButton from "../../../components/CustomButton";
import CustomModal from "../../../components/CustomModal/CustomModal";
import { getDiagnosticTemplateByIdWoLoader } from "../../../redux/reducers/clinicSlice";
import ContentToPrint from "../../../screens/CommonScreens/ContentToPrint/ContentToPrint";
import { a4PrintConfig } from "../../../util/commonConfig";
import { genderEnum } from "../../../util/enum";
import { normalizeReportHtml } from "../../../util/function";
import FilesWithCloseButton from "../../Hospital/ClinicPetDetails/PatientWorkbook/FilesWithCloseButton";

const DiagnosticReport = ({
  reportDownVsble,
  onCloseDownMod = () => {},
  selectedItem,
}) => {
  const dispatch = useDispatch();
  const contentToPrint = useRef(null);
  const printTitleRef = useRef("");
  const [tempSelectedItem, setTempSelectedItem] = useState(null);
  const {
    diagTemplateById,
    vitalsByIds,
    services: serviceList,
    selectedClinicBranch,
    details: clinicDetails,
  } = useSelector((state) => state?.clinic);
  const role = localStorage.getItem("role");
  const mandateDataRaw = sessionStorage.getItem("mandateData");
  const {
    services: clinicServiceList,
    vets: vetList,
    clinic: clinicDataDet,
  } = useMemo(() => {
    if (!mandateDataRaw) {
      return { services: [], vets: [], clinic: {} };
    }
    try {
      const reqData = JSON.parse(mandateDataRaw);
      return {
        services: Array.isArray(reqData?.services) ? reqData?.services : [],
        vets: Array.isArray(reqData?.vets) ? reqData?.vets : [],
        clinic: reqData?.clinic ?? {},
      };
    } catch {
      return { services: [], vets: [], clinic: {} };
    }
  }, [mandateDataRaw]);
  const clinicDet = clinicDataDet?.id ? clinicDataDet : clinicDetails;
  const services =
    role === "ROLE_DOCTOR" && selectedClinicBranch?.branchId
      ? // apntDet?.appointment?.hospitalId !== clinic?.id
        (serviceList?.data ?? [])
      : (clinicServiceList ?? []);

  useEffect(() => {
    // const reqTempleteId = getServiceDetById(
    //   selectedItem?.serviceId,
    // )?.diagnosticTemplateId;
    if (selectedItem?.templateId) {
      dispatch(getDiagnosticTemplateByIdWoLoader(selectedItem?.templateId));
    }
    setTempSelectedItem(selectedItem);
  }, [selectedItem]);
  const apntDet = selectedItem?.appoinment;

  const diagnosticReportHeaderRows = useMemo(() => {
    const referredBy = apntDet?.doctorName;
    let loggedInName = "-";
    try {
      const raw = localStorage.getItem("user");
      if (raw) {
        const p = JSON.parse(raw);
        loggedInName =
          [p?.salutation, p?.name].filter(Boolean).join(" ").trim() ||
          p?.userName ||
          p?.email ||
          "-";
      }
    } catch {
      loggedInName = "-";
    }
    const agePart = apntDet?.dob ? moment(apntDet?.dob).fromNow(true) : "";
    const sexPart = genderEnum?.[apntDet?.gender ?? ""];
    const ageSex =
      agePart && sexPart
        ? `${agePart} / ${sexPart}`
        : agePart || sexPart || "-";

    return [
      {
        leftLabel: "Lab Order ID:",
        leftValue:
          tempSelectedItem?.labOrderId ?? tempSelectedItem?.labOrderNo ?? "-",
        rightLabel: "Date:",
        rightValue: tempSelectedItem?.dueDate
          ? moment(tempSelectedItem.dueDate).format("DD-MM-YYYY")
          : "-",
      },
      {
        leftLabel: "Patient Reg. No:",
        leftValue: apntDet?.registrationNo ?? "-",
        rightLabel: "Vet Name:",
        rightValue: referredBy ?? "-",
      },
      {
        leftLabel: "Parent Name:",
        leftValue: apntDet?.userName ?? "-",
        rightLabel: "Species:",
        rightValue: apntDet?.petType ?? "-",
      },
      {
        leftLabel: "Pet Name:",
        leftValue: apntDet?.petName ?? "-",
        rightLabel: "Breed:",
        rightValue: apntDet?.breed ?? "-",
      },
      {
        leftLabel: "Lab Technician / Pathologist:",
        leftValue: loggedInName,
        rightLabel: "Age / Sex:",
        rightValue: ageSex,
      },
    ];
  }, [apntDet, tempSelectedItem]);

  const getServiceDetById = (servId, vrntId = null) => {
    if (!servId) return null;
    const reqServ = services?.find((ser) => ser?.serviceId === servId);
    if (vrntId) {
      return (
        reqServ?.serviceVariants?.find((vnt) => vnt?.variantId === vrntId) ?? {}
      );
    }
    return reqServ;
  };

  const renderTableRecord = () => {
    const tdLabel = {
      width: "22%",
      backgroundColor: "#f8f9fb",
      fontWeight: 600,
      color: "#1a1a1a",
      padding: "10px 12px",
      border: "1px solid #dadce0",
      fontSize: 14,
      verticalAlign: "middle",
      boxSizing: "border-box",
    };
    const tdValue = {
      width: "28%",
      backgroundColor: "#fff",
      fontWeight: 400,
      color: "#1a1a1a",
      padding: "10px 12px",
      border: "1px solid #dadce0",
      fontSize: 14,
      verticalAlign: "middle",
      boxSizing: "border-box",
    };
    return (
      <table
        className="diagnostic-report-native-table"
        style={{
          borderCollapse: "collapse",
          width: "100%",
          fontSize: 14,
        }}
      >
        <tbody>
          {diagnosticReportHeaderRows?.map((row, idx) => (
            <tr key={idx}>
              <td style={tdLabel}>{row?.leftLabel}</td>
              <td style={tdValue}>{row?.leftValue || "-"}</td>
              <td style={tdLabel}>{row?.rightLabel}</td>
              <td style={tdValue}>{row?.rightValue || "-"}</td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  };

  const renderCbcResultsTableUi = () => (
    <div className="diagnostic-cbc-results-wrap">
      <table className="diagnostic-cbc-results-table">
        <thead>
          <tr>
            <th>Test Description</th>
            {tempSelectedItem?.data?.some(
              (li) => li?.inputType === "Numeric",
            ) ? (
              <th>Units</th>
            ) : null}
            <th>Result</th>
            {tempSelectedItem?.data?.some(
              (li) => li?.inputType === "Numeric",
            ) ? (
              <th>Reference Range</th>
            ) : null}
          </tr>
        </thead>
        <tbody>
          {tempSelectedItem?.data
            ?.filter((li) => li?.questionType !== "fileupload" && li?.vitalId)
            ?.map((row, i) => {
              const lower = row?.lowerRange ?? "";
              const higher = row?.upperRange ?? "";
              let refRange = "";
              if (lower?.length > 0 || higher?.length > 0) {
                refRange = `${lower} - ${higher}`;
              }
              return (
                <tr key={`${Date.now()}_${i}`}>
                  <td>{row?.question}</td>
                  {tempSelectedItem?.data?.some(
                    (li) => li?.inputType === "Numeric",
                  ) ? (
                    <td>{row?.unit?.length ? row?.unit : "\u00A0"}</td>
                  ) : null}
                  <td>
                    {row?.answer?.length
                      ? Array.isArray(row?.answer)
                        ? row?.answer?.join(", ")
                        : (row?.answer ?? "")
                      : "\u00A0"}
                  </td>
                  {tempSelectedItem?.data?.some(
                    (li) => li?.inputType === "Numeric",
                  ) ? (
                    <td>{refRange?.length ? refRange : "\u00A0"}</td>
                  ) : null}
                </tr>
              );
            })}
        </tbody>
      </table>
    </div>
  );

  const handlePrint = useReactToPrint({
    content: () => contentToPrint.current,
    documentTitle: `${tempSelectedItem?.testName}_${Date.now()}`,
    pageStyle: a4PrintConfig,
    removeAfterPrint: true,
    onBeforeGetContent: () => {
      printTitleRef.current = document.title;
      document.title = "";
    },
    onAfterPrint: () => {
      document.title = printTitleRef.current ?? "";
    },
  });

  return (
    <CustomModal
      open={reportDownVsble}
      onClose={onCloseDownMod}
      header=""
      modal
      modalWidth={80}
      headerBold
    >
      <div className="scroll-80vh">
        {tempSelectedItem?.templateId ? (
          <ContentToPrint
            ref={contentToPrint}
            header={
              <div className="flex-row-ali-cen mv20">
                <div className="w35Per">
                  <div>
                    {clinicDet?.image ? (
                      <img src={clinicDet?.image} className="img-h75" alt="" />
                    ) : (
                      <div className="flex-center h50img">
                        <Typography className="font-bold fs30 white-color capitalize">
                          {clinicDet?.name?.[0]}
                        </Typography>
                      </div>
                    )}
                  </div>
                </div>
                <div className="w30Per flex-center">
                  <div className="font-bold fs20 blue-color">
                    {getServiceDetById(tempSelectedItem?.serviceId)
                      ?.diagnosticTemplateId
                      ? (diagTemplateById?.templateName ?? "")
                      : "Diagnostic Report"}
                  </div>
                </div>
                <div className="w35Per flex1-end">
                  <div className="prescription-doc-header-clinic">
                    <div className="font-bold blue-color fs16">
                      {clinicDet?.name ?? ""}
                    </div>
                    <div className="txt-regular fs12 blue-color">
                      {clinicDet?.address ?? ""}
                    </div>
                    {clinicDet?.taxId?.length > 0 ? (
                      <div className="flex-row-ali-cen mt5">
                        <div className="font-bold fs12 blue-color">
                          {/* CLINIC  */}
                          TAX ID:{" "}
                        </div>
                        <div className="txt-regular fs12 blue-color ml3">
                          {clinicDet?.taxId ?? ""}
                        </div>
                      </div>
                    ) : null}
                    {clinicDet?.mobile?.length > 0 ? (
                      <div className="flex-row-ali-cen mt5">
                        <div className="font-bold fs12 blue-color">
                          Contact:{" "}
                        </div>
                        <div className="txt-regular fs12 blue-color ml3">
                          {clinicDet?.mobile ?? ""}
                        </div>
                      </div>
                    ) : null}
                  </div>
                  ;
                </div>
              </div>
            }
            footer={
              <div className="prescription-print-footer-inner">
                <div className="mb20 mt10 flex-start prescription-print-footer-doctor-row">
                  <div>
                    <div className="txt-semi-bold fs12 black">
                      Clinician Signature
                      {/* {`Dr. ${apntDet?.appointment?.doctorName ?? ""}`} */}
                    </div>
                    {/* <div className="font-medium fs12 black">
                          Signature of Veterinarian
                        </div> */}
                  </div>
                </div>
                {clinicDet?.footer?.length > 0 ? (
                  <img src={clinicDet?.footer} alt="" />
                ) : null}
              </div>
            }
          >
            <tr>
              <td className="prescription-print-tbody-cell">
                <div className="prescription-print-body-inner">
                  {renderTableRecord()}
                  {(tempSelectedItem?.content ?? "")?.length > 0 ? (
                    <div
                      className="diagnostic-report-rich-content"
                      dangerouslySetInnerHTML={{
                        __html: normalizeReportHtml(tempSelectedItem?.content),
                      }}
                    />
                  ) : (
                    <>
                      {renderCbcResultsTableUi()}
                      {tempSelectedItem?.data
                        ?.filter(
                          (li) =>
                            !li?.vitalId && li?.questionType !== "fileupload",
                        )
                        ?.map((li, i) => (
                          <div key={`${li?.questionId}_${i}`} className="mv5">
                            <Typography className="txt-semi-bold fs14 black">
                              {li?.question}
                            </Typography>
                            <Typography className="txt-regular fs14 black">
                              {Array.isArray(li?.answer)
                                ? li?.answer?.join(", ")
                                : typeof li?.answer === "string"
                                  ? li?.answer
                                  : ""}
                            </Typography>
                          </div>
                        ))}
                    </>
                  )}
                </div>
              </td>
            </tr>
          </ContentToPrint>
        ) : (
          <div>
            <div className="flex-row-ali-cen">
              <Typography className="txt-semi-bold fs16 black">
                Type:
              </Typography>
              <Typography className="font-medium fs16 black3 ml5">
                {tempSelectedItem?.type}
              </Typography>
              <Typography className="txt-semi-bold fs16 black ml10">
                Variant:
              </Typography>
              <Typography className="font-medium fs16 black3 ml5">
                {
                  getServiceDetById(
                    tempSelectedItem?.serviceId,
                    tempSelectedItem?.variantId,
                  )?.variantName
                }
              </Typography>
              <Typography className="txt-semi-bold fs16 black ml10">
                Collected by:
              </Typography>
              <Typography className="font-medium fs16 black3 ml5">
                {tempSelectedItem?.collectedByName}
              </Typography>
            </div>
            {tempSelectedItem?.data?.[0]?.files?.length > 0 ? (
              <div className="mt20">
                <FilesWithCloseButton
                  files={tempSelectedItem?.data?.[0]?.files?.map((li) => ({
                    previewUrl: li,
                    file: null,
                  }))}
                  disabled
                />
              </div>
            ) : null}
            <Typography className="fs14 blue-color font-bold mt10">
              Remarks
            </Typography>
            <Typography
              className="fs12 txt-regular black"
              style={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}
              component="div"
            >
              {(tempSelectedItem?.remark ?? "")
                ?.split("\n")
                ?.map((line, index) => (
                  <div key={index}>{line || "\u00A0"}</div>
                ))}
            </Typography>
          </div>
        )}
        {tempSelectedItem?.templateId ? (
          <div className="flex1-end mv20">
            <div>
              <CustomButton text="Print" onClick={handlePrint} smallBtn />
            </div>
          </div>
        ) : null}
      </div>
    </CustomModal>
  );
};

export default DiagnosticReport;
